(function () {
  var instances = new WeakMap();

  var prefersReducedMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  var tabProofDuplicateItems = function (group) {
    group.querySelectorAll('.custom-marquee__item[aria-hidden="true"] a').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });
  };

  var getScrollSpeed = function (section) {
    var scrollSpeed = parseInt(section.dataset.scrollSpeed, 10) || 16;
    return 16 / scrollSpeed;
  };

  var registerGsapPlugins = function () {
    if (!window.gsap) {
      return false;
    }

    if (window.Draggable) {
      window.gsap.registerPlugin(window.Draggable);
    }

    if (window.InertiaPlugin) {
      window.gsap.registerPlugin(window.InertiaPlugin);
    }

    return true;
  };

  var gsapPluginsReady = function (needsDraggable) {
    if (!window.gsap) {
      return false;
    }

    if (!needsDraggable) {
      return true;
    }

    return typeof window.Draggable === 'function' && typeof window.InertiaPlugin !== 'undefined';
  };

  var horizontalLoop = function (items, config) {
    var gsap = window.gsap;
    items = gsap.utils.toArray(items);
    config = config || {};

    var tl = gsap.timeline({
      repeat: config.repeat,
      paused: config.paused,
      defaults: { ease: 'none' },
      onReverseComplete: function () {
        tl.totalTime(tl.rawTime() + tl.duration() * 100);
      },
    });

    var length = items.length;
    var startX = items[0].offsetLeft;
    var times = [];
    var widths = [];
    var xPercents = [];
    var curIndex = 0;
    var pixelsPerSecond = (config.speed || 1) * 100;
    var snap =
      config.snap === false
        ? function (value) {
            return value;
          }
        : gsap.utils.snap(config.snap || 1);
    var totalWidth;
    var populateWidths = function () {
      items.forEach(function (el, i) {
        widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px'));
        xPercents[i] = snap(
          (parseFloat(gsap.getProperty(el, 'x', 'px')) / widths[i]) * 100 +
            gsap.getProperty(el, 'xPercent')
        );
      });
    };
    var getTotalWidth = function () {
      return (
        items[length - 1].offsetLeft +
        (xPercents[length - 1] / 100) * widths[length - 1] -
        startX +
        items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
        (parseFloat(config.paddingRight) || 0)
      );
    };
    var i;
    var item;
    var curX;
    var distanceToStart;
    var distanceToLoop;

    populateWidths();

    gsap.set(items, {
      xPercent: function (index) {
        return xPercents[index];
      },
    });

    gsap.set(items, { x: 0 });
    totalWidth = getTotalWidth();

    for (i = 0; i < length; i++) {
      item = items[i];
      curX = (xPercents[i] / 100) * widths[i];
      distanceToStart = item.offsetLeft + curX - startX;
      distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');

      tl.to(
        item,
        {
          xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
          duration: distanceToLoop / pixelsPerSecond,
        },
        0
      )
        .fromTo(
          item,
          { xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100) },
          {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false,
          },
          distanceToLoop / pixelsPerSecond
        )
        .add('label' + i, distanceToStart / pixelsPerSecond);

      times[i] = distanceToStart / pixelsPerSecond;
    }

    var toIndex = function (index, vars) {
      vars = vars || {};

      if (Math.abs(index - curIndex) > length / 2) {
        index += index > curIndex ? -length : length;
      }

      var newIndex = gsap.utils.wrap(0, length, index);
      var time = times[newIndex];

      if (time > tl.time() !== index > curIndex) {
        vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }

      curIndex = newIndex;
      vars.overwrite = true;
      return tl.tweenTo(time, vars);
    };

    tl.next = function (vars) {
      return toIndex(curIndex + 1, vars);
    };

    tl.previous = function (vars) {
      return toIndex(curIndex - 1, vars);
    };

    tl.current = function () {
      return curIndex;
    };

    tl.toIndex = function (index, vars) {
      return toIndex(index, vars);
    };

    tl.updateIndex = function () {
      curIndex = Math.round(tl.progress() * (items.length - 1));
    };

    tl.times = times;
    tl.progress(1, true).progress(0, true);

    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }

    if (config.draggable && typeof window.Draggable === 'function') {
      var proxy = document.createElement('div');
      var wrap = gsap.utils.wrap(0, 1);
      var ratio;
      var startProgress;
      var draggable;
      var dragSnap;
      var roundFactor;
      var dragTrigger = config.dragTrigger || items[0].parentNode;

      var align = function () {
        tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio));
      };

      var syncIndex = function () {
        tl.updateIndex();
      };

      if (typeof window.InertiaPlugin === 'undefined') {
        console.warn(
          '[Custom Marquee] InertiaPlugin is required for momentum-based dragging.'
        );
      }

      var finalizeDrag = function () {
        syncIndex();
        startProgress = tl.progress();
        gsap.set(proxy, { x: 0 });
      };

      draggable = window.Draggable.create(proxy, {
        trigger: dragTrigger,
        type: 'x',
        dragClickables: true,
        onPressInit: function () {
          if (typeof config.onDragStart === 'function') {
            config.onDragStart(tl, dragTrigger);
          }
        },
        onPress: function () {
          startProgress = tl.progress();
          tl.progress(0);
          populateWidths();
          totalWidth = getTotalWidth();
          ratio = 1 / totalWidth;
          dragSnap = totalWidth / items.length;
          roundFactor = Math.pow(10, ((dragSnap + '').split('.')[1] || '').length);
          tl.progress(startProgress);
        },
        onDrag: align,
        onThrowUpdate: align,
        inertia: true,
        snap:
          config.dragSnap === false
            ? false
            : function (value) {
                var n = Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
                return (n - n % 1) / roundFactor;
              },
        onRelease: function () {
          if (!this.isThrowing) {
            finalizeDrag();
          } else {
            syncIndex();
          }

          if (!this.isThrowing && typeof config.onDragEnd === 'function') {
            config.onDragEnd(tl, dragTrigger);
          }
        },
        onThrowComplete: function () {
          finalizeDrag();

          if (typeof config.onDragEnd === 'function') {
            config.onDragEnd(tl, dragTrigger);
          }
        },
      })[0];

      tl.draggable = draggable;
    } else if (config.draggable) {
      console.warn('[Custom Marquee] GSAP Draggable was not found. Drag is disabled.');
    }

    return tl;
  };

  var destroyMarquee = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.onResize) {
      window.removeEventListener('resize', instance.onResize);
    }

    instance.itemListeners.forEach(function (entry) {
      entry.item.removeEventListener('mouseenter', entry.onEnter);
      entry.item.removeEventListener('mouseleave', entry.onLeave);
    });

    if (instance.timeline && instance.timeline.draggable) {
      instance.timeline.draggable.kill();
    }

    if (instance.track) {
      instance.track.classList.remove('is-dragging');
    }

    if (instance.timeline) {
      instance.timeline.kill();
    }

    if (window.gsap && instance.items) {
      window.gsap.set(instance.items, { clearProps: 'all' });
    }

    instances.delete(section);
  };

  var initMarquee = function (section) {
    if (!section || instances.has(section)) {
      return null;
    }

    if (!window.gsap) {
      return null;
    }

    var track = section.querySelector('[data-custom-marquee-track]');
    var group = section.querySelector('[data-custom-marquee-group]');

    if (!track || !group) {
      return null;
    }

    var items = group.querySelectorAll('.custom-marquee__item');

    if (!items.length) {
      return null;
    }

    tabProofDuplicateItems(group);

    var reverse = section.dataset.reverse === 'true';
    var pauseOnHover = section.dataset.pauseOnHover === 'true';
    var draggableEnabled = section.dataset.draggable === 'true';
    var reducedMotion = prefersReducedMotion();
    var timeline = null;
    var itemListeners = [];
    var isDragging = false;
    var isHovered = false;

    var setPlayback = function () {
      if (!timeline) {
        return;
      }

      timeline.timeScale(isDragging || (pauseOnHover && isHovered) ? 0 : 1);
    };

    var preserveTimelineProgress = function (activeTimeline) {
      if (!activeTimeline) {
        return;
      }

      var progress = activeTimeline.progress();
      activeTimeline.progress(progress);
    };

    if (!reducedMotion) {
      timeline = horizontalLoop(items, {
        repeat: -1,
        speed: getScrollSpeed(section),
        draggable: draggableEnabled,
        dragSnap: false,
        reversed: reverse,
        dragTrigger: track,
        paddingRight: parseFloat(window.gsap.getProperty(items[0], 'marginRight', 'px')),
        onDragStart: function (activeTimeline, dragTrigger) {
          isDragging = true;
          dragTrigger.classList.add('is-dragging');
          setPlayback();
        },
        onDragEnd: function (activeTimeline, dragTrigger) {
          isDragging = false;
          dragTrigger.classList.remove('is-dragging');
          isHovered = dragTrigger.matches(':hover');
          preserveTimelineProgress(activeTimeline);
          setPlayback();
        },
      });

      if (pauseOnHover) {
        var onEnter = function () {
          isHovered = true;
          setPlayback();
        };
        var onLeave = function () {
          if (isDragging) {
            return;
          }

          isHovered = false;
          setPlayback();
        };

        track.addEventListener('mouseenter', onEnter);
        track.addEventListener('mouseleave', onLeave);

        itemListeners.push({
          item: track,
          onEnter: onEnter,
          onLeave: onLeave,
        });
      }
    }

    var resizeTimer;
    var onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        destroyMarquee(section);
        initMarquee(section);
      }, 400);
    };

    window.addEventListener('resize', onResize);

    instances.set(section, {
      section: section,
      track: track,
      group: group,
      items: items,
      timeline: timeline,
      itemListeners: itemListeners,
      onResize: onResize,
    });

    return timeline;
  };

  var initMarquees = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-marquee]').forEach(function (section) {
      initMarquee(section);
    });
  };

  var bootstrap = function () {
    if (!registerGsapPlugins()) {
      return;
    }

    initMarquees();
  };

  var waitForReady = function () {
    var needsDraggable = document.querySelector('[data-custom-marquee][data-draggable="true"]');

    if (!gsapPluginsReady(needsDraggable)) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;

        if (gsapPluginsReady(needsDraggable)) {
          window.clearInterval(timer);

          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(bootstrap);
          } else {
            bootstrap();
          }
        } else if (attempts > 50) {
          window.clearInterval(timer);
          console.warn('[Custom Marquee] GSAP plugins were not found.');
        }
      }, 100);

      return;
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(bootstrap);
    } else {
      bootstrap();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForReady);
  } else {
    waitForReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (registerGsapPlugins()) {
      initMarquees(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-custom-marquee]').forEach(function (section) {
      destroyMarquee(section);
    });
  });

  document.addEventListener('shopify:section:reorder', function () {
    document.querySelectorAll('[data-custom-marquee]').forEach(function (section) {
      destroyMarquee(section);
    });
    bootstrap();
  });
})();
